import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { BagResponseV4 } from "./bag.type";
import { buildExpandQueryValue, ExpandOptions } from "./utils/expand";

export type RemoveProductOptions = {
  chameleonRequestInstance: ChameleonRequest;
  asosBagSessionToken: string;
  bagId: string;
  bagItemId: string;
  authHeader: string;
  store: string;
  lang: string;
  expand?: ExpandOptions;
};

export async function removeProduct({
  chameleonRequestInstance,
  asosBagSessionToken,
  bagId,
  bagItemId,
  authHeader,
  store,
  lang,
  expand,
}: RemoveProductOptions) {
  const expandQueryValue = buildExpandQueryValue(expand);

  const url = getApiUrl({
    path: `/commerce/bag/v4/bags/${bagId}/product/${bagItemId}`,
    searchParams: {
      lang,
      ...(expandQueryValue ? { expand: expandQueryValue } : {}),
    },
  });

  const { data, responseHeaders } =
    await chameleonRequestInstance.delete<BagResponseV4>(url, {
      headers: {
        "asos-c-store": store,
        "asos-bag-session-token": asosBagSessionToken,
        Authorization: authHeader,
      },
    });

  return {
    data,
    bagSessionToken: responseHeaders["asos-bag-session-token"] as string,
  };
}
